/**
 * App
 */

import App from './App'
export default App



// WEBPACK FOOTER //
// ./src/pages/App/index.ts